<template>
  <div
    class=""
    style="position:relative;"
    v-if="adv">
    <div
      v-if="adv.status==='canceled' || !plan.adv_enabled || !adv.promoteur.plan.adv_enabled"
      class="frontdrop"></div>
    <div
      v-if="!(isAdmin && isPromoteur) && adv.use_electronic_signature"
      class="columns is-gapless is-border-top is-border-bottom has-background-white is-border-left is-border-right is-minH50p is-flex is-marginless">
      <div class="column is-self-centered is-padding-right is-padding-left">
        <div class="is-self-centered">
          <span class="is-uppercase title is-6">Procédure Dématérialisée</span>
        </div>
      </div>
    </div>
    <div
      v-if="isAdmin && isPromoteur"
      class="columns is-gapless is-padding-left-small is-padding-right-small is-vcentered is-minH50p is-marginless"
      :class="!adv.is_digital ? 'is-border-top has-background-light is-border-left is-border-right ' : 'has-background-dark'">
      <div class="column is-narrow">
        <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
          <div class="">
            <input
              v-if="inProcess"
              id="is_digital"
              v-model="adv.is_digital"
              :disabled="inProcess"
              @click="procedureEnCours"
              name="is_digital"
              class="switch is-success is-rounded"
              type="checkbox">
            <input
              v-else
              id="is_digital"
              v-model="adv.is_digital"
              name="is_digital"
              class="switch is-success is-rounded"
              type="checkbox">
            <label
              for="is_digital"
              style="font-size: 12.5px"
              :class="!adv.is_digital ? '' : 'has-text-white'"
              class="is-uppercase">Procédure Dématérialisée</label>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isAdmin && isPromoteur && adv.is_digital"
      class="columns is-gapless is-padding-left-small is-padding-right-small is-vcentered is-minH50p is-marginless"
      :class="!adv.use_electronic_signature ? 'is-border-top has-background-light is-border-left is-border-right ' : 'has-background-dark'">
      <div class="column is-narrow">
        <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
          <div class="">
            <input
              id="use_electronic_signature"
              v-model="adv.use_electronic_signature"
              name="use_electronic_signature"
              class="switch is-success is-rounded"
              type="checkbox">
            <label
              for="use_electronic_signature"
              style="font-size: 12.5px"
              :class="!adv.use_electronic_signature ? '' : 'has-text-white'"
              class="is-uppercase">Autoriser signature electronique par le vendeur</label>
          </div>
        </div>
      </div>
    </div>
    <template v-if="!adv.is_digital && isPromoteur && isAdmin">
      <div class="is-border is-margin-bottom-xxsmall">
        <div class="columns is-gapless has-background-white is-border-bottom is-padding is-marginless-bottom">
          <div class="column is-narrow is-padding-right">
            <div class="has-vadBadge--topright has-vadBadge--out-quarter">
              <i class="fal fa-6x fa-file-contract"></i>
            </div>
            <!-- <div class="column is-narrow has-vadBadge--topright has-vadBadge--out-quarter"><i class="fal fa-6x fa-file-contract"></i><span data-tooltip="Aecg Lorem." class="vadBadge is-large is-bordered is-success tooltip is-tooltip-top"><span class="icon"><i class="fas fa-check"></i></span></span></div> -->
          </div>
          <div
            class="column is-self-centered is-padding-top-small"
            :class="{'has-content-disabled' : !(isAdmin && isPromoteur)}">
            <r-label
              label="Date de signature contrat de réservation"
              :is-required="false"
              :value="adv.signature_date"></r-label>
            <div class="row-width-actions-bar is-border">
              <div class="columns is-gapless">
                <div class="column is-narrow has-background-white-bis is-flex">
                  <date-picker
                    id="signDatePickr"
                    :model="adv.signature_date"
                    @input="$store.commit('modifyCurrentAdv', { key: 'signature_date', value: $event, patch: true })"
                    class="is-self-centered"
                    :field-class="'is-margin-left-xxsmall is-margin-right-xsmall is-self-centered'"
                    :input-class="'is-w110p'"
                    :style-version="2"></date-picker>
                </div>
                <div class="column is-padding-left-small is-self-centered columns is-gapless is-vcentered is-marginless">
                  <div class="column is-narrow">
                    <div
                      class="is-flex dot is-white is-medium is-margin-right-small"
                      :class="documentIsValid ? 'has-background-success' : 'is-border'">
                      <i
                        v-if="documentIsValid"
                        class="fal has-text-white fa-check is-size-6"></i>
                    </div>
                  </div>
                  <div class="column">
                    <span class="is-size-6">Contrat signé</span>
                  </div>
                </div>
                <div
                  class="column is-narrow is-border-left"
                  v-if="!documentIsValid">
                  <div class="file">
                    <label class="">
                      <input
                        @change="uploadDocument($event.target.files)"
                        class="file-input"
                        accept="image/*, .pdf"
                        type="file"
                        name="resume">
                      <span class="page-header-btn is-small is-dark">
                        <span
                          v-if="!loadingDoc"
                          class="">Lier un document</span>
                        <span
                          v-else
                          class="is-margin-xxsmall is-size-4 icon"><i class="fas fa-spinner fa-spin "></i></span>
                      </span>
                    </label>
                  </div>
                </div>
                <template v-else>
                  <div class="is-border-left">
                    <button
                      class="page-header-btn is-small is-square tooltip is-tooltip-top"
                      @click="download()"
                      data-tooltip="Télécharger document lié">
                      <span
                        class="icon is-size-4"><i class="fal fa-download"></i></span>
                    </button>
                  </div>
                  <div class="is-border-left">
                    <button
                      class="page-header-btn is-small is-square tooltip is-tooltip-top"
                      @click="unlink()"
                      data-tooltip="Supprimer document lié">
                      <span
                        class="icon is-size-4"><i class="fal fa-unlink"></i></span>
                    </button>
                  </div>
                </template>
              </div>
            </div>
            <div class="columns is-gapless is-marginless-bottom is-margin-top-small">
              <div class="column is-8 is-self-centered">
                <span class="is-uppercase is-size-7">DATE INFORMATIQUE DE Passage du lot en ADV : <b>Le {{ adv.created_on | dtFormat('DD/MM/YYYY HH:mm') }}</b></span>
              </div>
              <div class="column is-4 is-padding-left">
                <date-picker
                  id="signImputationDatePickr"
                  :model="adv.signature_imputation_date"
                  @input="$store.commit('modifyCurrentAdv', { key: 'signature_imputation_date', value: $event, patch: true })"
                  :field-class="'is-marginless-bottom'"
                  :input-class="'is-fullwidth'"
                  :style-version="2"
                  label="Date d'imputation réservation"></date-picker>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="isAdmin"
          class="has-background-white is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small">
          <span class="is-uppercase title is-6">COURRIER SRU</span>
        </div>
        <div
          v-for="(buyer, idx) in adv.buyers_data"
          :key="buyer.pk"
          class="is-border-top">
          <div
            v-if="isAdmin"
            class="columns is-gapless has-background-white is-marginless-bottom">
            <div class="column is-narrow is-padding-top-small is-padding-bottom-small is-padding-left">
              <div class="has-vadBadge--topright has-vadBadge--out-quarter">
                <i class="fal fa-3x fa-file-alt"></i>
              </div>
            </div>
            <div class="column is-self-centered is-padding-left">
              <div class="title is-5">
                <span class="is-uppercase">{{ buyer.last_name }} </span><span>{{ buyer.first_name }}</span>
              </div>
            </div>
            <div class="column is-narrow is-self-centered is-padding-top-small is-padding-bottom-small is-padding-right">
              <button
                @click="openPreview(buyer)"
                :disabled="!buyer.is_valid || !buyer.is_complete"
                :class="{'disabled tooltip is-tooltip-top': !buyer.is_valid || !buyer.is_complete}"
                data-tooltip="Contact incomplet, génération impossible"
                class="button is-small is-light is-border is-transform-none minW140p">
                <span>Voir document (.pdf)</span>
              </button>
            </div>
          </div>
          <div
            v-if="isAdmin"
            class="has-background-light is-padding-top-small is-border-top  is-padding-bottom-small is-padding-right is-padding-left">
            <div class="columns">
              <div class="column is-4">
                <date-picker
                  :id="'sending_date-' + idx"
                  :model="adv.signature_data.sru_list[idx].date_envoi"
                  @input="$store.commit('modifyCurrentAdv', { key: `signature_data.sru_list[${idx}].date_envoi`, value: $event})"
                  class="is-self-centered"
                  :field-class="'is-margin-left-xxsmall is-margin-right-xsmall is-fullwidth is-self-centered'"
                  :input-class="'is-fullwidth'"
                  :style-version="2"
                  :label="'DATE D’ENVOI POSTAL DU COURRIER : ' + buyer.last_name + ' ' + buyer.first_name"
                  :is-required="false"></date-picker>
              </div>
              <div class="column is-4">
                <r-label
                  :label="'Numéro A/R'"
                  :is-required="false"
                  :value="adv.signature_data.sru_list[idx].numero_ar"></r-label>
                <div class="field has-addons">
                  <div class="control">
                    <a class="button is-static is-border is-square">
                      <span class="icon"><i class="far fa-mail-bulk"></i></span>
                    </a>
                  </div>
                  <div class="control is-expanded has-icons-right">
                    <v-input
                      :id="'ar-' + idx"
                      name="ref"
                      @input="val => update(val, idx)"
                      :model="adv.signature_data.sru_list[idx].numero_ar"
                      v-validate="''"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      data-vv-as="numero a/r"
                      data-type-cy="input"
                      data-value-cy="input_ref">
                    </v-input>
                  </div>
                  <div class="control">
                    <a
                      class="button is-grey is-inverted is-border is-square"
                      @click="deleteNumAr(idx)">
                      <i class="fas fa-times"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="column is-4">
                <date-picker
                  :id="'reception_date-' + idx"
                  :model="adv.signature_data.sru_list[idx].date_reception"
                  @input="$store.commit('modifyCurrentAdv', { key: `signature_data.sru_list[${idx}].date_reception`, value: $event})"
                  class="is-self-centered"
                  :field-class="'is-margin-left-xxsmall is-margin-right-xsmall is-fullwidth is-self-centered'"
                  :input-class="'is-fullwidth'"
                  :label="'DATE DE RÉCEPTION a/r'"
                  :is-required="false"
                  :style-version="2"></date-picker>
              </div>
            </div>
            <div>
              <div class="column is-4">
                <date-picker
                  :id="'deadline_date-' + idx"
                  :model="adv.signature_data.sru_list[idx].deadline_date"
                  @input="$store.commit('modifyCurrentAdv', { key: `signature_data.sru_list[${idx}].deadline_date`, value: $event})"
                  class="is-self-centered"
                  :field-class="'is-margin-left-xxsmall is-margin-right-xsmall is-fullwidth is-self-centered'"
                  :input-class="'is-fullwidth'"
                  :label="'DATE BUTOIR ACTE'"
                  :is-required="false"
                  :style-version="2"></date-picker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-if="!loadingProcess && !loadingProcessStart">
        <div v-if="!isProcess">
          <div
            v-if="!isComplete"
            class="notification is-danger has-text-centered is-marginless">
            <p class="is-uppercase is-size-7 has-text-weight-medium">
              <span class="icon"><i class="fas fa-exclamation-triangle"></i></span>
              Les informations du contrat de réservation sont incomplètes
            </p>
          </div>
          <div
            v-else
            class="notification is-success has-text-centered is-marginless">
            <p class="is-uppercase is-size-7">
              <span class="icon"><i class="fas fa-check-square"></i></span>
              <span class="has-text-weight-medium">DOSSIER COMPLET</span>
            </p>
          </div>
          <div
            v-if="!isComplete"
            class="columns is-centered is-4 is-gapless has-background-light is-border">
            <div class="column is-flex is-narrow is-padding-top is-padding-left is-padding-bottom">
              <div class="has-vadBadge--topright has-vadBadge--out-quarter">
                <i class="fal fa-6x fa-file-pdf"></i>
                <span
                  v-if="!isComplete"
                  class="vadBadge is-large is-bordered is-danger tooltip is-tooltip-top"
                  data-tooltip="Information manquante">
                  <span class="icon"><i class="fas fa-exclamation"></i></span>
                </span>
                <span
                  v-else
                  class="vadBadge is-large is-bordered is-success tooltip is-tooltip-top"
                  data-tooltip="Dossier complet">
                  <span class="icon"><i class="fas fa-check"></i></span>
                </span>
              </div>
            </div>
            <div class="column is-self-centered is-narrow is-padding-top is-padding-left is-padding-bottom">
              <div>
                <span
                  class="title is-3"
                  style="font-weight: 500;">Contrat de réservation ADV {{ adv.ref }}</span>
              </div>
              <div v-if="!isComplete">
                <router-link
                  tag="a"
                  class="is-size-6 is-underline"
                  :to="{name: 'ContratDeReservation'}">
                  Modifier les informations
                </router-link>
              </div>
            </div>
          </div>
          <div
            class="is-padding-left is-padding-right is-padding-top-xsmall is-border-right is-border-left has-background-white is-padding-bottom-xsmall is-minH50p is-flex"
            :class="!isAdmin || documentChecked ? 'is-border-bottom' : ''">
            <div class="is-self-centered">
              <span class="is-uppercase is-size-7">Signataires du document</span>
            </div>
          </div>
          <div
            v-if="!promoteurChecked || !buyersChecked"
            class="notification is-warning has-text-centered is-marginless">
            <p class="is-uppercase is-size-7 has-text-weight-medium">
              <span class="icon has-text-danger is-size-5"><i class="fas fa-exclamation-circle"></i></span>
              Vérifier les informations des différents signataires. Un numéro de téléphone portable valide est
              obligatoire pour le ou les acquéreurs.
            </p>
          </div>
          <div class="has-background-white">
            <template v-for="(buyer, index) in buyers">
              <membre-adv
                class="has-background-white is-border-bottom"
                :key="index"
                :index="index"
                :is-grey="true"
                :membre="buyer"
                :is-co-acquereur="index > 0"
                @deleteCobuyer="deleteBuyer"
                @updateContact="openModalContactInfo"
                :is-membre-promoteur="false"
                :modal-promoteur="false"
                :from-resa="true"
                :can-edit="true"></membre-adv>
            </template>
            <membre-adv
              class="is-border-bottom"
              @openModalPromoteurInfo="openModalPromoteurInfo"
              :from-resa="false"
              :is-check="promoteurChecked"
              :membre="adv.promoteur_data"
              :can-edit="isAdmin && isPromoteur"
              :is-membre-promoteur="true"
              :is-co-acquereur="false"
              :modal-promoteur="true"></membre-adv>
          </div>
        </div>
        <div v-else>
          <template v-for="(procedure, idx) in procedures">
            <procedure-item
              :key="idx"
              :adv-pk="advPk"
              :signatures="adv.signature_data.sru_list"
              :source="procedure"
              :resa="adv"
              @updateProcedure="updateProcedure"></procedure-item>
          </template>
        </div>
        <div
          v-if="isComplete && !pendingSubmit && !inProcess"
          class="columns is-gapless is-centered has-background-white is-padding-top-small is-padding-bottom-small is-margin-bottom-xsmall">
          <div
            v-if="!canStartProcedure || !adv.reservation_contract"
            class="button is-marginless is-warning is-border is-transform-none is-fullwidth is-radius">
            <p
              class="is-uppercase is-size-7"
              style="display: inline-flex; align-items: center;">
              <img
                style="height: 15px; margin-right: 10px;"
                src="/img/loading/Rolling-0.6s-204px.svg"
                alt="loader">
              <span class="has-text-weight-medium">Contrat en cours de génération, merci de patienter</span>
            </p>
          </div>
          <div
            v-else-if="docExisting.length && (isEventFinished || haveDocs) || docExisting.length === 0"
            class="column is-5">
            <button
              type="button"
              :disabled="!canStartProcedure || !adv.reservation_contract || preProdEnv"
              @click="postProcedure()"
              data-tooltip="Option non activée"
              :class="{'tooltip is-tolltip-bottom': !canStartProcedure}"
              class="is-minH50p button is-success is-transform-none is-fullwidth">
              <div class="veryFastAnimation">
                <span>Lancer procédure de signature électronique</span>
              </div>
            </button>
          </div>
        </div>
      </div>
      <div v-if="loadingProcess || loadingProcessStart">
        <div v-if="loadingProcess">
          <div
            v-if="errorProcedure"
            class="notification is-danger has-text-centered is-marginless">
            <p class="is-uppercase is-size-7">
              <span
                v-if="errorProcedure !== 'RUNNING_PROCEDURE'"
                class="icon has-text-white"><i class="fas fa-exclamation-triangle"></i></span>
              <span v-if="errorProcedure !== 'RUNNING_PROCEDURE'">Une Erreur a été détéctée sur le format </span>
              <b v-if="errorProcedure === 'EMAIL_NOT_VALID' || errorProcedure === 'PHONE_NOT_VALID' || errorProcedure === 'YOUSIGN_LASTNAME_ERROR' || errorProcedure === 'YOUSIGN_FIRSTNAME_ERROR'">
                <span v-if="errorProcedure === 'EMAIL_NOT_VALID'"> de l'email</span>
                <span v-if="errorProcedure === 'PHONE_NOT_VALID'">du numéro de téléphone </span>
                <span v-if="errorProcedure === 'YOUSIGN_LASTNAME_ERROR'">du nom </span>
                <span v-if="errorProcedure === 'YOUSIGN_FIRSTNAME_ERROR'">du prénom </span>
                d'un des signataires
              </b>
              <b
                v-else-if="errorProcedure === 'RUNNING_PROCEDURE'"
                style="display: inline-flex; align-items: center;">
                <img
                  style="height: 18px; margin-right: 10px; filter: brightness(0) invert(1);"
                  src="/img/loading/Rolling-0.6s-204px.svg"
                  alt="loader">
                <span>Attention: une procédure est déjà en cours d'exécution, merci de patienter</span>
              </b>
            </p>
          </div>
          <div
            v-else
            class="notification is-warning has-text-centered is-marginless">
            <p class="is-uppercase is-size-7">
              Le temps de lancement de la procédure peut prendre quelques minutes et est conditionné par le débit de
              votre connexion internet
            </p>
          </div>
          <div
            v-if="errorProcedure !== 'RUNNING_PROCEDURE'"
            class="column columns is-paddingless is-marginless is-border">
            <div class="column is-narrow is-padding-large is-paddingless-right">
              <div class="is-padding-left-large is-padding-right-large">
                <img
                  v-if="!errorProcedure"
                  style="height: 100px;"
                  src="/img/loader-procedure-signature.gif">
                <img
                  v-else
                  style="height: 100px;"
                  src="/img/loader-procedure-signature.jpg">
              </div>
            </div>
            <div class="column is-padding-large is-narrow">
              <div class="columns is-gapless is-vcentered is-marginless">
                <div class="column is-narrow">
                  <span
                    class="is-size-3 icon is-padding-right-small is-medium"
                    :class="{'has-text-grey-light' : width < 3 && !errorProcedure, 'has-text-success' : width >= 3, 'has-text-danger' : width < 3 && errorProcedure}">
                    <i class="fas fa-check-circle"></i>
                  </span>
                </div>
                <div class="column">
                  <span :class="width > 3 ? '' : 'has-text-grey-light'">
                    Ouverture de la connexion sécurisée au service
                  </span>
                </div>
              </div>
              <div class="columns is-gapless is-vcentered is-marginless is-margin-top-xsmall">
                <div class="column is-narrow">
                  <span
                    class="is-size-3 icon is-padding-right-small is-medium"
                    :class="{'has-text-grey-light' : width < 35 && !errorProcedure, 'has-text-success' : width >= 35, 'has-text-danger' : errorProcedure}">
                    <i class="fas fa-check-circle"></i>
                  </span>
                </div>
                <div class="column">
                  <span :class="width > 35 ? '' : 'has-text-grey-light'">
                    Récupération des informations acquéreur(s)
                  </span>
                </div>
              </div>
              <div class="columns is-gapless is-vcentered is-marginless is-margin-top-xsmall">
                <div class="column is-narrow">
                  <span
                    class="is-size-3 icon is-padding-right-small is-medium"
                    :class="{'has-text-grey-light' : width < 65 && !errorProcedure, 'has-text-success' : width >= 65, 'has-text-danger' : errorProcedure}">
                    <i class="fas fa-check-circle"></i>
                  </span>
                </div>
                <div class="column">
                  <span :class="width > 65 ? '' : 'has-text-grey-light'">
                    Compilation des annexes
                  </span>
                </div>
              </div>
              <div class="columns is-gapless is-vcentered is-marginless is-margin-top-xsmall">
                <div class="column is-narrow">
                  <span
                    class="is-size-3 icon is-padding-right-small is-medium"
                    :class="{'has-text-grey-light' : width < 100 && !errorProcedure , 'has-text-success' : width >= 100, 'has-text-danger' : width < 100 && errorProcedure}">
                    <i class="fas fa-check-circle"></i>
                  </span>
                </div>
                <div class="column">
                  <span :class="width === 100 ? '' : 'has-text-grey-light'">
                    Synchronisation et lancement de la procédure
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="errorProcedure !== 'RUNNING_PROCEDURE'"
            class="column has-background-white is-border-left is-border-bottom is-border-right">
            <progress
              id="myBar"
              class="progress is-success"
              :value="width"
              max="100">
              {{ width }}%
            </progress>
            <!-- <div id="myProgress">
              <div id="myBar"></div>
            </div> -->
          </div>
          <div
            v-if="errorProcedure && (errorProcedure !== 'RUNNING_PROCEDURE')"
            class="columns is-gapless is-centered has-background-white is-padding-top-small is-padding-bottom-small is-margin-bottom-xsmall">
            <div class="column is-6 is-margin-left-small">
              <a
                v-if="errorProcedure === 'EMAIL_NOT_VALID' || errorProcedure === 'PHONE_NOT_VALID' || errorProcedure === 'YOUSIGN_LASTNAME_ERROR' || errorProcedure === 'YOUSIGN_FIRSTNAME_ERROR'"
                @click="errorProcessUpdate()"
                class="is-minH50p button specific-btn is-transform-none is-fullwidth">
                <div class="veryFastAnimation">
                  <span>Modifier et relancer votre procédure de signature électronique</span>
                </div>
              </a>
              <!-- <a
                v-else-if="errorProcedure === 'RUNNING_PROCEDURE'"
                @click="stopProcess()"
                class="is-minH50p button is-success is-transform-none is-fullwidth">
                <div class="veryFastAnimation">
                  <span>Charger procédure</span>
                </div>
              </a> -->
            </div>
          </div>
        </div>
        <spinner-round :is-loading="loadingProcessStart"></spinner-round>
      </div>
    </template>
    <div
      v-if="(isAdmin && isPromoteur || currentUser.active_all_contact) && !loadingProcess"
      class="has-background-white">
      <div class="row-width-actions-bar columns is-gapless is-marginless">
        <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
          <span class="is-uppercase title is-6">Commentaire</span>
        </div>
        <div class="column is-narrow is-border-left">
        </div>
      </div>
      <template v-if="openComment">
        <div
          v-if="!openCommentWysi && comment"
          @click="openWysiwyg"
          class="vadDiscussion is-border-top"
          style="cursor: pointer;">
          <div
            class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
            <div
              class="content"
              v-if="(isAdmin || currentUser.active_all_contact) && comment"
              v-html="comment"></div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div class="">
                <button
                  @click="openWysiwyg"
                  class="is-min-height-full">
                  <span class="icon is-small"><i class="fal fa-edit"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="is-border-top columns is-gapless">
          <div class="column">
            <wysiwyg-editor
              :light="true"
              :tooltip-top="true"
              :model="comment"
              @change="val => comment = val"
              class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
            </wysiwyg-editor>
          </div>
          <div class="actionsOnRow actionsOnRow--vertical">
            <div>
              <button
                @click="patchComment()"
                type="button"
                class="button"
                :class="[(baseComment !== comment) ? 'is-success' : 'is-info']"
                :disabled="(baseComment === comment)">
                <span class="icon is-small">
                  <i
                    v-if="loadComment"
                    class="fas fa-spinner fa-spin"></i>
                  <i
                    v-else
                    class="fal fa-save"></i>
                </span>
              </button>
            </div>
            <div class="">
              <button
                :disabled="!baseComment"
                type="button"
                :class="{'actionsOnRow-btn--hoverIsDanger': comment}"
                @click="comment?openCommentWysi = false:null; comment = baseComment">
                <span class="icon is-small"><i class="fal fa-times"></i></span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ProcedureItem from './ProcedureItem'
import MembreAdv from '../MembreAdv'
import { DefaultValues, Adv, Upload } from '@/mixins'
import { mapGetters, mapState } from 'vuex'
import { isNil, isEmpty } from 'lodash'
import { bus, EVENTS } from '@/bus'

export default {
  name: 'Signature',
  components: { MembreAdv, ProcedureItem },
  mixins: [DefaultValues, Adv, Upload],
  data () {
    return {
      validDocument: null,
      width: 1,
      min: 1,
      max: 0,
      idBar: null,
      finished: false,
      ouverture: false,
      recuperation: false,
      compilation: false,
      synchronisation: false,
      is25: true,
      errorProcedure: null,
      files: [],
      loadingProcessStart: null,
      procedures: [],
      loadingProcess: false,
      documentsReady: false,
      docExisting: []
    }
  },
  computed: {
    ...mapState(['modal']),
    ...mapGetters(['isAdmin']),
    /**
      * promoteur is complete
      * @returns {boolean}
      */
    promoteurChecked () {
      if (!this.adv.promoteur_data) return
      return !isNil(this.adv.promoteur_data.rep_last_name) &&
          !isNil(this.adv.promoteur_data.company_name) &&
          !isNil(this.adv.promoteur_data.rep_first_name) &&
          !isEmpty(this.adv.promoteur_data.rep_address) &&
          !isNil(this.adv.promoteur_data.rep_phone) &&
          !isNil(this.adv.promoteur_data.rep_email)
    },
    /**
      * can start procedure
      * @returns {boolean}
      */
    canStartProcedure () {
      return (this.isAdmin && this.isPromoteur && this.canUseElectronicSign && this.adv.documents !== null) || (!(this.isAdmin && this.isPromoteur) && this.adv.use_electronic_signature && !this.adv.signature_date && this.promoteurCanSign && this.adv.documents !== null)
    },
    /**
      * all buyers complete
      * @returns {boolean}
      */
    buyersChecked () {
      let total = 0
      for (let buyer of this.buyers) {
        if (buyer.is_complete) total += 1
      }
      return total === this.buyers.length
    },
    /**
      * can use demat sign
      * @returns {boolean}
      */
    canUseDematSign () {
      return !this.userIsAnonymous && !this.lotIsDeleted && !this.programIsDeleted
    },
    /**
      * is in process
      * @returns {boolean}
      */
    inProcess () {
      let active = this.procedures.find(x => {
        // V3 YOUSIGN ---->
        return x.status === 'draft' || x.status === 'ongoing' || x.status === 'done'
        // return x.status === 'active' || x.status === 'finished'
      })
      return active
    },
    /**
      * there is procedures
      * @returns {boolean}
      */
    isProcess () {
      return this.procedures && this.procedures.length
    },
    /**
      * has this.contrat
      * @returns {boolean}
      */
    documentIsValid () {
      return this.contrat
    },
    /**
      * document is complete
      * @returns {boolean}
      */
    documentChecked () {
      return !this.contratDeReservationDocuments.find(x => {
        return x.document === null
      })
    },
    canStartWithDoc () {
      return this.adv.is_complete && this.adv.reservation_contract
    },
    isEventFinished () {
      return this.documentsReady
    },
    haveDocs () {
      return this.adv.documents.length > 0
    },
    preProdEnv () {
      return process.env.VUE_APP_ENV === 'PRE_PROD'
    }
  },
  watch: {
    'adv.is_digital' (to) {
      this.$store.commit('modifyCurrentAdv', { key: 'is_digital', value: to, patch: true })
    },
    'adv.use_electronic_signature' (to) {
      this.$store.commit('modifyCurrentAdv', { key: 'use_electronic_signature', value: to, patch: true })
    },
    quickview ({ mode, params, results }) {
      if (results) {
        if (mode === 'CONTACT_UPDATE' && params && params.fromBuyerEdit) {
          this.putBuyerAndUpdate(results.contact, params.index, params.advProgram).then(ok => {
            if (ok) this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
          })
        } else if (mode === 'PROMOTEUR_UPDATE') {
          this.$store.commit('modifyCurrentAdv', { key: 'promoteur_data', value: results.promoteur })
          this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        }
      }
    },
    'adv.documents': {
      handler: function (to) {
        this.contratDeReservationDocuments = to
        this.documentsAreReady(this.contratDeReservationDocuments)
      }
    }
  },
  async created () {
    // if (!this.adv.documents) {
    //   this.adv.documents = null
    // }
    this.files = new FormData()
    if (this.adv.signed_contract) this.contrat = this.adv.signed_contract
    await this.getProcedures()
    bus.$on(EVENTS.ADV_PROCEDURE_UPDATED, (data) => {
      if (data.reservation === this.advPk) {
        this.updateAdvProcedure(data.procedure)
      }
    })
    bus.$on(EVENTS.ADV_PROCEDURE_CREATED, (data) => {
      if (data.reservation === this.advPk) {
        this.createAdvProcedure(data.procedure)
      }
    })
    bus.$on(EVENTS.ADV_PROCEDURE_ERROR, ({ reservation, error }) => {
      if (reservation === this.advPk) {
        this.errorProcedure = error
        var elem = document.getElementById('myBar')
        elem.classList.remove('is-success')
        elem.classList.add('is-danger')
      }
    })
    this.checkDocuments()
  },
  destroyed () {
    bus.$off([EVENTS.ADV_PROCEDURE_UPDATED, EVENTS.ADV_PROCEDURE_ERROR, EVENTS.ADV_PROCEDURE_CREATED])
  },
  methods: {
    /**
      * create adv procedure
      * @param {object} procedure
      */
    async createAdvProcedure (procedure) {
      try {
        await this.initAdv()
        await this.getProcedure(procedure)
        clearTimeout(this.idBar)
        this.stopProcess()
        this.$toasted.global.success('Procédure de signature initiée')
      } catch (err) {
        console.log(err)
      }
    },
    /**
      * update adv procedure
      * @param {object} procedure
      */
    async updateAdvProcedure (procedure) {
      await this.initAdv()
      await this.getProcedure(procedure)
    },
    /**
      * open buyer preview
      * @param {string} buyerPk
      */
    async openPreview (buyer) {
      if (buyer.is_valid && buyer.is_complete) {
        let request = await this.getSru(buyer.pk)
        let params = {
          link: request.data
        }
        this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW_SAAS', params })
      }
    },
    /**
      * get sru pdf
      * @param {string} buyerPk
      */
    getSru (buyerPk) {
      return this.$api.axios.get(`pdf/sru/${this.adv.pk}/${buyerPk}`)
    },
    /**
      * fram for progress bar
      */
    async frame () {
      if (this.width >= 89 || this.errorProcedure) {
        clearTimeout(this.idBar)
      } else {
        this.width++
        let newRand = Math.floor(Math.random() * (this.max - this.min + 1) + this.min)
        // this.idBar = setTimeout(this.frame, newRand * 100)
        this.idBar = setTimeout(() => this.frame(), newRand * 100)
      }
    },
    /**
      * after error procedure
      */
    async afterErrorProcedure () {
      this.stopProcess()
      await this.initAdv()
      await this.getProcedures()
    },
    /**
      * stop process
      */
    stopProcess () {
      this.loadingProcess = false
      this.errorProcedure = false
      this.width = 1
      this.min = 1
      this.max = 0
      this.idBar = null
    },
    /**
      * update procedure
      * @param {object} procedure
      */
    updateProcedure (procedure) {
      let idx = this.procedures.findIndex(x => {
        return x.pk === procedure.pk
      })
      if (idx >= 0) {
        this.procedures.splice(idx, 1, procedure)
      }
    },
    /**
      * post procedure
      */
    async postProcedure () {
      this.loadingProcess = true
      this.progressBar()
      try {
        await this.$api.post(this.$resources.RESERVATION_PROCEDURE(this.advPk))
      } catch (err) {
        this.errorProcedure = err.response.data.message
        var elem = document.getElementById('myBar')
        elem.classList.remove('is-success')
        elem.classList.add('is-danger')
      }
    },
    /**
      * progress bar
      */
    progressBar () {
      let rand = Math.floor(Math.random() * (this.max - this.min + 1) + this.min)
      this.idBar = setTimeout(() => this.frame(), rand * 120)
    },
    /**
      * upload document
      * @param {array} files
      */
    async uploadDocument (files) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        this.validDocument = await this.checkAutorizedFile(file)
        this.files.append('file[]', file, file.name)
      }
      if (this.validDocument === false) {
        setTimeout(() => {
          this.validDocument = null
        }, 2000)
        return
      }
      let uploadFiles = this.files
      this.loadingDoc = true
      let config = {
        onUploadProgress: progressEvent => {
          this.progressData = Math.floor((progressEvent.loaded * 120) / progressEvent.total)
        }
      }
      try {
        await this.setFusToken()
        let res = await this.$fus.post({ data: uploadFiles, config })
        let hostedFiles = res.data.slice()
        hostedFiles = hostedFiles.map(x => {
          return {
            fus_id: x.id,
            cloudinary_id: x.cloudinary_id,
            cloudinary_version: x.cloudinary_version,
            path: x.path,
            filename: x.filename,
            display: x.display || true
          }
        })
        this.loadingDoc = false
        this.contrat = hostedFiles[0]
        this.$store.commit('modifyCurrentAdv', { key: 'signed_contract', value: hostedFiles[0], patch: true })
        this.$toasted.global.success('Le document à été téléchargé avec succès')
      } catch (e) {
        this.loadingDoc = false
        console.log(e)
      }
    },
    /**
      * unlink contrat
      */
    unlink () {
      this.contrat = null
      this.$store.commit('modifyCurrentAdv', { key: 'signed_contract', value: null, patch: true })
    },
    /**
      * delete num ar
      * @param {number} idx
      */
    deleteNumAr (idx) {
      let key = `signature_data.sru_list[${idx}].numero_ar`
      this.$store.commit('modifyCurrentAdv', { key, value: null })
    },
    /**
      * update
      * @param {string} value
      * @param {number} elem - index
      */
    update (value, index) {
      let key = `signature_data.sru_list[${index}].numero_ar`
      if (value && (index || index === 0)) {
        this.$store.commit('modifyCurrentAdv', { key, value })
      } else if (value === '' && index) {
        this.$store.commit('modifyCurrentAdv', { key, value: null })
      }
    },
    /**
      * download contrat
      */
    download () {
      let link = document.createElement('a')
      link.href = this.adv.signed_contract.path
      link.target = '_blank'
      link.click()
    },
    /**
      * running procedure message
      */
    procedureEnCours () {
      this.$toasted.global.danger('Procedure de signature électronique en cours : annuler la procédure pour faire des modifications')
    },
    /**
      * get procedure
      * @param {string} procedurePk
      */
    async getProcedure (procedurePk) {
      let index = this.procedures.findIndex(x => x.pk === procedurePk)
      try {
        let { data } = await this.$api.getOne(this.$resources.PROCEDURE, procedurePk)
        if (index >= 0) {
          this.procedures.splice(index, 1, data)
        } else {
          this.procedures.push(data)
        }
      } catch (err) {
        console.log(err)
      }
    },
    /**
      * get all procedures
      */
    async getProcedures () {
      this.loadingProcessStart = true
      try {
        let request = await this.$api.get(this.$resources.RESERVATION_PROCEDURE(this.advPk))
        this.procedures = request.data.items
        this.loadingProcessStart = false
      } catch (e) {
        this.loadingProcessStart = false
        console.log(e)
      }
    },
    documentsAreReady (docs) {
      if (docs) {
        this.documentsReady = true
      }
    },
    checkDocuments () {
      if (this.program && this.program.documents) {
        for (let doc of this.program.documents) {
          if (doc.destination.includes('reservation')) {
            this.docExisting.push(doc)
          }
        }
      }
      if (this.lot && this.lot.documents) {
        for (let doc of this.lot.documents) {
          if (doc.destination.includes('reservation')) {
            this.docExisting.push(doc)
          }
        }
      }
    },
    errorProcessUpdate () {
      // this.stopProcess()
      this.$router.push({ name: 'ContratDeReservation', params: { id: this.advPk } })
    }
  }
}
</script>
<style lang="sass">
.specific-btn
  color: white
  background-color: #5c5c5c
.specific-btn:hover
  color: white
.light
  color: white
</style>
